<template>
  <!-- 模板内容保持不变 -->
  <div class="content-wrapper2" ref="contentWrapper">
    <!-- 文字区域 -->
    <div v-if="this.$i18n.locale === 'zh'" class="galaxy-content-wrapper">
      <div class="upper-texts">
        <p style="font-size: var(--font-size-xl)" class="galaxy-text-item galaxy-text-one">{{ $t('series.galaxy_desc1') }}</p>
        <p style="font-size: var(--font-size-xl)" class="galaxy-text-item galaxy-text-one">{{ $t('series.galaxy_desc2') }}</p>
        <p class="galaxy-text-item galaxy-text-two-two">{{ $t('series.galaxy_desc3') }}</p>
        <p class="galaxy-text-item galaxy-text-two">{{ $t('series.galaxy_desc4') }}</p>
        <p class="galaxy-text-item galaxy-text-two">{{ $t('series.galaxy_desc5') }}</p>
        <p class="galaxy-text-item galaxy-text-three">{{ $t('series.galaxy_desc6') }}</p>
        <p class="galaxy-text-item galaxy-text-three">{{ $t('series.galaxy_desc7') }}</p>
        <p class="galaxy-text-item galaxy-text-three">{{ $t('series.galaxy_desc8') }}</p>
        <p class="galaxy-text-item galaxy-text-three">{{ $t('series.galaxy_desc9') }}</p>
      </div>
    </div>

    <div v-else class="galaxy-content-wrapper">
      <div class="upper-texts">
        <p class="galaxy-text-item galaxy-text-one">Weak vacuum due to leaking？ <br> Bring It On.</p>
        <p class="galaxy-text-item galaxy-text-two">Galaxy Mars 50/55 <br>Multi-stages Vacuum Pump</p>
        <p class="galaxy-text-item galaxy-text-three">The Multistage Vacuum Champion <br>Multi-Patented Centrifugal
          Design.</p>
        <p class="galaxy-text-item galaxy-text-four">The secret weapon of<br>global premium brands.</p>
        <p class="galaxy-text-item galaxy-text-five">Unshakable Reliability,</p>
        <p class="galaxy-text-item galaxy-text-six">24/7 operation under brutal <br>conditions High-Flow Vacuum Lock,
        </p>
        <p class="galaxy-text-item galaxy-text-seven">Maintains grip even with cutting leaks.</p>
      </div>
    </div>

    <!-- 图片区域 -->
    <div class="galaxy-image-container">
      <img
          :src="imageSrc"
          :alt="imageAlt"
          class="main-image"
          ref="mainImage"
          @load="handleImageLoad"
          loading="lazy"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextImageLayout',
  props: {
    imageSrc: {
      type: String,
      default: () => require("../../static/series/galaxymars.png")
    },
    imageAlt: {
      type: String,
      default: "Galaxy Mars 设备展示"
    }
  },
  data() {
    return {
      timeline: null,
      animationInited: false,
      imageLoaded: false,
      isMobile: window.innerWidth < 768
    };
  },
  methods: {
    handleImageLoad() {
      this.imageLoaded = true;
      if (!this.animationInited) {
        this.initAnimation();
      }
    },
    initAnimation() {
    },
    preventScroll(e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    },
    updateDeviceType() {
      this.isMobile = window.innerWidth < 768;
    }
  },
  mounted() {
    window.addEventListener('resize', this.updateDeviceType);

    this.$nextTick(() => {
      const isMobile = this.isMobile;

      // 核心优化：调整移动端动画参数 - 减慢速度并下移元素
      const animationParams = {
        mobile: {
          startTrigger: 'top 110%',   // 触发点更靠下（元素下移效果）
          endTrigger: 'bottom 80%',   // 结束点更靠下，延长动画区间
          scrub: 4,                   // 增大scrub值，减慢动画速度
          duration: 2,                // 延长动画时长
          imageY: 0,                // 图片初始下移200px左右（抵消后续上移动画）
          textInitialY: 200,          // 文字初始下移200px
          textStep1: 100,             // 第一步文字位置（相对初始位置上移100px）
          textStep2: -50,             // 第二步文字位置（相对初始位置上移250px）
          textStep3: -120,            // 英文第三步
          textStep4: -180,            // 英文第四步
          textStep5: -200,            // 英文第五步
          textStep6: -250             // 英文第六步
        },
        pc: {
          startTrigger: 'top 80%',
          endTrigger: 'bottom 40%',
          scrub: 3,
          duration: 2,
          imageY: -50,
          textInitialY: 0,
          textStep1: -170,
          textStep2: -300,
        }
      };

      const params = isMobile ? animationParams.mobile : animationParams.pc;

      // 初始化位置：移动端元素整体下移200px
      this.$gsap.set('.galaxy-text-item', {
        y: params.textInitialY
      });

      this.$gsap.set('.galaxy-text-one', {
        color: "#333"
      });

      const staticImage = document.querySelector('.galaxy-image-container');
      const bgParent = staticImage.parentElement;

      // 创建主时间线
      const masterTimeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: '.galaxy-image-container',
          start: 'top 60%',
          end: 'bottom 100%',
          markers: false,
          once: false,
          scrub: 3,
          toggleActions: 'play none none reverse',
          onEnter: () => {
            // 1. 记录元素在文档流中的位置（相对于文档顶部/左侧，而非视口）
            const rect = staticImage.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
            // 计算元素相对于文档的绝对位置（固定定位时以此为基准）
            const absoluteTop = rect.top + scrollTop;
            const absoluteLeft = rect.left + scrollLeft;

            // 2. 先冻结元素样式，避免布局抖动
            staticImage.style.willChange = 'transform, position';
            staticImage.style.transition = 'none'; // 禁用过渡动画

            // 3. 设置固定定位，使用相对于文档的坐标转换为视口内的固定位置
            staticImage.style.position = 'fixed';
            // 固定定位的 top/left 是相对于视口，需减去当前滚动偏移
            staticImage.style.top = `${absoluteTop - scrollTop}px`;
            staticImage.style.left = `${absoluteLeft - scrollLeft}px`;
            staticImage.style.width = `${rect.width}px`;
            staticImage.style.height = `${rect.height}px`;

            // 4. 清除可能影响布局的样式（如原有的margin/padding）
            staticImage.style.margin = '0';
            staticImage.style.padding = '0';
            staticImage.style.transform = 'translateZ(0)';
          },
          onLeave: () => {
            const viewportRect = staticImage.getBoundingClientRect();
            const parentRect = bgParent.getBoundingClientRect();
            staticImage.style.position = 'absolute';
            staticImage.style.top = `${viewportRect.top - parentRect.top}px`;
            staticImage.style.left = `${viewportRect.left - parentRect.left}px`;
            staticImage.style.width = `${viewportRect.width}px`;
            staticImage.style.height = `${viewportRect.height}px`;
          },
          onLeaveBack: () => {
            staticImage.style.transition = 'none';
            staticImage.style.position = 'absolute';
            staticImage.style.top = '';
            staticImage.style.left = '';
            staticImage.style.width = '';
            staticImage.style.height = '';
            staticImage.style.willChange = '';
            staticImage.style.transform = '';
            // 强制重绘后再启用过渡（可选）
            void staticImage.offsetWidth; // 触发重绘
            staticImage.style.transition = '';
          },
        }
      });

      if (this.$i18n.locale === 'zh') {
        const slowFactor = 1.5; // 放慢 1.5 倍（值越大越慢）

        masterTimeline
            // 第一步动画：延长持续时间
            .to('.galaxy-image-container', {
              y: params.imageY,
              duration: params.duration * slowFactor, // 持续时间放大
              ease: 'power2.in',
            }, 0)
            .to('.galaxy-text-item', {
              y: params.textStep1,
              duration: params.duration * slowFactor,
              ease: 'power2.in',
            }, 0)
            .to('.galaxy-text-one', {
              color: "#808080",
              duration: params.duration * slowFactor,
            }, 0)
            .to('.galaxy-text-two-two', {
              color: "#46b1e1",
              duration: params.duration * slowFactor,
            }, 0)
            .to('.galaxy-text-two', {
              color: "#333",
              duration: params.duration * slowFactor,
            }, 0);

// 第二步动画：延长持续时间 + 增加步骤间隔（可选）
        masterTimeline
            .to('.galaxy-text-item', {
              y: params.textStep2,
              duration: params.duration * slowFactor, // 持续时间放大
              ease: 'power2.in'
            }, isMobile ? 2 * slowFactor : 1 * slowFactor) // 步骤间隔也按比例放大
            .to('.galaxy-text-two', {
              color: "#808080",
              duration: params.duration * slowFactor,
            }, isMobile ? 2 * slowFactor : 1 * slowFactor)
            .to('.galaxy-text-three', {
              color: "#333",
              duration: params.duration * slowFactor,
            }, isMobile ? 2 * slowFactor : 1 * slowFactor);
      } else {
        // 英文动画序列
        masterTimeline
            // 第一步
            .to('.galaxy-image-container', {
              y: params.imageY,
              duration: params.duration + 1,
              ease: 'power2.in',
            }, 0.1)
            .to('.galaxy-text-item', {
              y: params.textStep1,
              duration: params.duration,
              ease: 'power2.in',
            }, 0)
            .to('.galaxy-text-one', {
              color: "#808080",
              duration: params.duration,
            }, 0)
            .to('.galaxy-text-two', {
              color: "#46b1e1",
              duration: params.duration,
            }, 0);

        // 第二步
        masterTimeline
            .to('.galaxy-image-container', {
              y: params.imageY,
              duration: params.duration + 1,
              ease: 'power2.in',
            }, isMobile ? 2.1 : 2.1)
            .to('.galaxy-text-item', {
              y: params.textStep3,
              duration: params.duration,
              ease: 'power2.in'
            }, isMobile ? 2 : 2)
            .to('.galaxy-text-three', {
              color: "#333",
              duration: params.duration,
            }, isMobile ? 2 : 2);

        // 第三步到第六步按相同逻辑调整，保持节奏一致
        masterTimeline
            .to('.galaxy-image-container', {
              y: params.imageY,
              duration: params.duration + 1,
              ease: 'power2.in',
            }, isMobile ? 4.1 : 4.1)
            .to('.galaxy-text-item', {
              y: params.textStep4,
              duration: params.duration,
              ease: 'power2.in'
            }, isMobile ? 4 : 4)
            .to('.galaxy-text-three', {
              color: "#808080",
              duration: params.duration,
            }, isMobile ? 4 : 4)
            .to('.galaxy-text-four', {
              color: "#333",
              duration: params.duration,
            }, isMobile ? 4 : 4);

        // 后续步骤保持相同调整逻辑...
        masterTimeline
            .to('.galaxy-image-container', {
              y: params.imageY,
              duration: params.duration + 1,
              ease: 'power2.in',
            }, isMobile ? 6.1 : 6.1)
            .to('.galaxy-text-item', {
              y: params.textStep5,
              duration: params.duration,
              ease: 'power2.in'
            }, isMobile ? 6 : 6)
            .to('.galaxy-text-four', {
              color: "#808080",
              duration: params.duration,
            }, isMobile ? 6 : 6)
            .to('.galaxy-text-five', {
              color: "#333",
              duration: params.duration,
            }, isMobile ? 6 : 6);

        masterTimeline
            .to('.galaxy-image-container', {
              y: params.imageY,
              duration: params.duration + 1,
              ease: 'power2.in',
            }, isMobile ? 8.1 : 8.1)
            .to('.galaxy-text-item', {
              y: params.textStep5,
              duration: params.duration,
              ease: 'power2.in'
            }, isMobile ? 8 : 8)
            .to('.galaxy-text-five', {
              color: "#808080",
              duration: params.duration,
            }, isMobile ? 8 : 8)
            .to('.galaxy-text-six', {
              color: "#333",
              duration: params.duration,
            }, isMobile ? 8 : 8);

        masterTimeline
            .to('.galaxy-image-container', {
              y: params.imageY,
              duration: params.duration + 1,
              ease: 'power2.in',
            }, isMobile ? 10.1 : 10.1)
            .to('.galaxy-text-item', {
              y: params.textStep6,
              duration: params.duration,
              ease: 'power2.in'
            }, isMobile ? 10 : 10)
            .to('.galaxy-text-six', {
              color: "#808080",
              duration: params.duration,
            }, isMobile ? 10 : 10)
            .to('.galaxy-text-seven', {
              color: "#333",
              duration: params.duration,
            }, isMobile ? 10 : 10);
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateDeviceType);
  }
};
</script>

<style scoped>
/* 保持原有样式，仅调整移动端布局 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.content-wrapper2 {
  width: 100%;
  margin-top: 20vw;
  position: relative;
  padding: 0 4vw;
  height: 150vh;
}

.galaxy-content-wrapper {
  margin: 0 auto 8vw;
  padding: 2vw;
  width: 100%;
  position: relative;
  z-index: 2;
}

.upper-texts {
  display: flex;
  flex-direction: column;
  line-height: 1.6;
  font-size: 4.5vw;
  color: #333;
  gap: 1.5vw;
  align-items: flex-start;
  margin: 0 auto;
  max-width: 90%;
  white-space: nowrap;
}

.galaxy-text-item {
  max-width: 100%;
  color: #808080;
  text-align: left;
}

.galaxy-image-container {
  position: absolute;
  width: 100%;
  border-radius: 4vw;
  top: 0;
  left: 0;
  z-index: 3;
  overflow: hidden;
  margin: 0 auto;
}

.main-image {
  width: 90%;
  height: auto;
  display: block;
  margin: 0 auto;
}

/* 移动端样式优化 */
@media (max-width: 768px) {
  .upper-texts {
    white-space: normal;
    font-size: clamp(16px, 5vw, 20px);
    gap: 0;
  }

  .galaxy-image-container {
    margin-top: -80px; /* 增加图片顶部距离，配合下移调整 */
  }

  .content-wrapper2 {
    margin-top: 100px; /* 减少顶部距离，平衡整体下移 */
    min-height: 120vh; /* 增加高度，避免内容被截断 */
    padding-bottom: 50px; /* 增加底部 padding */
  }
}

/* PC端样式 */
@media (min-width: 768px) {
  .content-wrapper2 {
    margin-top: 600px;
    height: 800px;
    padding: 0;
  }

  .galaxy-content-wrapper {
    width: 30%;
    margin: 0 auto;
    padding: 20px;
  }

  .upper-texts {
    font-size: 2.5em;
    line-height: 1.5;
    gap: 0;
    white-space: nowrap;
  }

  .galaxy-image-container {
    position: absolute;
    width: 60%;
    top: 116px;
    left: 276px;
    border-radius: 8px;
  }
}
</style>
